/* ============ Header: transparent over the hero, solid once scrolled past it ============ */
(function () {
  var header = $('#site-header');
  if (!header) return;

  function onScroll() {
    var hero = $('.feature, .story-hero');
    var limit = hero ? hero.offsetHeight - 90 : 0;
    header.classList.toggle('is-solid', window.scrollY > limit);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
